import { render, staticRenderFns } from "./room_list.vue?vue&type=template&id=b65cedec&scoped=true&"
import script from "./room_list.vue?vue&type=script&lang=js&"
export * from "./room_list.vue?vue&type=script&lang=js&"
import style0 from "./room_list.vue?vue&type=style&index=0&id=b65cedec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65cedec",
  null
  
)

export default component.exports